var map = {
	"./_attack.jpg": 649,
	"./_fire.jpg": 650,
	"./_guard.jpg": 651,
	"./astro.png": 652,
	"./attack.jpg": 653,
	"./fire.jpg": 654,
	"./guard.jpg": 655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 648;